module.exports = __webpack_public_path__ + "assets/img/submitBtn_graduate.eba6fc28.png";